module.exports = __webpack_public_path__ + "static/media/dreamBox.af2dcb5e.jpg";